
import { defineComponent } from 'vue';
import { Form, Input, Spin } from 'ant-design-vue';
import Editor from '@/components/Editor.vue';
import { JobBasicInfo, JobBasicInfoController } from './js/jobBasicInfo';

export default defineComponent({
  name: 'JobBasicInfo',
  components: {
    aForm: Form,
    aFormItem: Form.Item,
    aInput: Input,
    aTextarea: Input.TextArea,
    Editor,
    aSpin: Spin,
  },
  data() {
    return {
      labelCol: {
        span: 2,
        offset: 1,
      },
      wrapperCol: {
        span: 20,
      },
    };
  },
  methods: {
  },
  setup() {
    const jobBasicInfo = new JobBasicInfo();
    const jobBasicInfoController = new JobBasicInfoController(jobBasicInfo);
    return {
      jobBasicInfo,
      jobBasicInfoController,
    };
  },
});
